import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { Subject } from "rxjs";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-segmented-bar",
  templateUrl: "segmented-bar.component.html",
  standalone: false,
})
export class SegmentedBarComponent extends BaseComponent {
  @Input() uniqueID: any = "segmented-bar";
  @Input() options: Array<any>;
  @Input() white: boolean = false;
  @Input() videoMode: boolean = false;
  @Input() forceWhite: boolean = false;
  @Input() workAsRadioButton: boolean = false;
  @Input() nowrap: boolean = false;
  @Input() isUsedAsTab: boolean = false;
  @Input() theme: "brand-color" | "neutral" = "brand-color";
  @Input() ariaLabelledBy: string;
  @Output() selected: EventEmitter<any> = new EventEmitter();
  public selectedEvent: Subject<any> = new Subject();

  constructor(userService: UserService) {
    super(userService);
  }

  selectOption(option, e?) {
    if (e) e.preventDefault();
    if (!this.workAsRadioButton && !this.isUsedAsTab) {
      this.options.forEach((item) => (item.selected = item.name != option.name ? false : true));
      this.selected.emit(option);
      this.selectedEvent.next(option);
    }
  }

  clickSelectOption(option, e?) {
    if (e) e.preventDefault();
    this.options.forEach((item) => (item.selected = item.name != option.name ? false : true));
    this.selected.emit(option);
    this.selectedEvent.next(option);
  }

  selectPrevOption(idx) {
    if (this.isUsedAsTab) {
      const idx = this.getSelectedIdx();
      let selectedIdx = idx - 1;
      if (selectedIdx < 0) selectedIdx = this.options.length - 1;
      this.options.forEach((item, index) => (item.selected = index === selectedIdx ? true : false));
      this.selected.emit(this.options[selectedIdx]);
      this.selectedEvent.next(this.options[selectedIdx]);
    }
  }

  selectNextOption(idx) {
    if (this.isUsedAsTab) {
      const idx = this.getSelectedIdx();
      let selectedIdx = idx + 1;
      if (selectedIdx === this.options.length) selectedIdx = 0;
      this.options.forEach((item, index) => (item.selected = index === selectedIdx ? true : false));
      this.selected.emit(this.options[selectedIdx]);
      this.selectedEvent.next(this.options[selectedIdx]);
    }
  }

  private getSelectedIdx = () => {
    const selectedIdx = this.options.findIndex((option) => option.selected === true);
    return selectedIdx;
  };
}
